module.exports = __webpack_public_path__ + "img/goole-play.6b1603dc.png";